import ChatScreen from './chatScreen'
import subscribeScreen from './subscribeScreen'

export default {
  Chat: ChatScreen,
  Subscribe: subscribeScreen
}
